import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { BodyComponentObject, ButtonsComponentObject, FooterComponentObject, HeaderComponentObject } from '@trendbuild/trend-cloud-api';
import { AbstractComponent, CampaignService, CloudAPIData, FirebaseService, UtilHelper } from 'lib-trend-core';

@Component({
    selector: 'campaign-cloud-api-template',
    templateUrl: './campaign-cloud-api-template.v2.component.html',
    styleUrls: ['./campaign-cloud-api-template.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignCloudApiTemplateComponent extends AbstractComponent implements OnInit, OnDestroy, OnChanges {

  avatarUrl: string = 'https://firebasestorage.googleapis.com/v0/b/infinite7-70f9d.appspot.com/o/blank.png?alt=media&token=fea2ea97-edbd-4589-a52e-e4b8d786be0b';

  @Input('cloudAPIData') cloudAPIData: CloudAPIData;

  textHead: string;
  type: string;
  inputText: string;

  constructor(
    injector: Injector,
    public firebaseService: FirebaseService,
    public campaignService: CampaignService
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['cloudAPIData']?.currentValue) {
      this.textHead = '';
      this.inputText = '';
      this.type = this.headerComponent?.format || 'TEXT';
      this.updateTemplateParams();
    }
  }

  public get headerComponent(): HeaderComponentObject {
    return <HeaderComponentObject>this.cloudAPIData.template?.components.find(c => c.type === 'HEADER');
  }

  public get bodyComponent(): BodyComponentObject {
    return <BodyComponentObject>this.cloudAPIData.template?.components.find(c => c.type === 'BODY');
  }

  public get footerComponent(): FooterComponentObject {
    return <FooterComponentObject>this.cloudAPIData.template?.components.find(c => c.type === 'FOOTER');
  }

  public get buttonsComponent(): ButtonsComponentObject {
    return <ButtonsComponentObject>this.cloudAPIData.template?.components.find(c => c.type === 'BUTTONS');
  }

  formatWhatsappMessage(text: string): string {
    if (text) {
      return UtilHelper.formatWhatsappMessage(text);
    }
    return '';
  }

  getType() {
    return this.type;
  }

  updateTemplateParams(): void {

    const headerParams = this.cloudAPIData?.headerParams || [];
    const bodyParams = this.cloudAPIData?.bodyParams || [];

    const baseText = this.bodyComponent?.text;
    this.inputText = (baseText || '').replace(/\{\{(\d+)\}\}/g, (match: string, group1: string) => {
      const idx = parseInt(group1, 10) - 1;
      return (bodyParams[idx] != null && bodyParams[idx] !== '') ? bodyParams[idx] : '';
    });

    if (this.headerComponent) {
      if (this.headerComponent.format === 'TEXT') {
        const headerText = this.headerComponent?.text;
        this.textHead = (headerText || '').replace(/\{\{(\d+)\}\}/g, (match: string, group1: string) => {
          const idx = parseInt(group1, 10) - 1;
          return (headerParams[idx] != null && headerParams[idx] !== '') ? headerParams[idx] : '';
        });
      } else {
        this.textHead = headerParams[0] || '';
      }
    }
  }

  getTypeButton(index: number): string {
    return this.buttonsComponent?.buttons[index]?.type;
  }
}
